<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'receiveConsignmentFooter',
    setup() {},
    props: {
        itemCount: Number,
        accessToken: String
    }
})
</script>

<template>
    <div class="row">
        <div class="col-12">
            <div class="mobileFooter btn-receive text-center pointer" @click="$store.dispatch('consignment/processAwaitingReceipt', accessToken)">
                <span>Receive Consignment ({{itemCount}})</span>
            </div>	
        </div>
    </div>
</template>
